import { CLOSE_DRAWER, OPEN_DRAWER, SET_DRAWER_HYDRATION_STATE } from '../../actions/action-types';
import type { DrawerHydrationState } from '../../actions/drawer';

type Action =
  | { type: typeof CLOSE_DRAWER }
  | { type: typeof OPEN_DRAWER; id: string }
  | { type: typeof SET_DRAWER_HYDRATION_STATE; payload: DrawerHydrationState }
  | { type: '' };

type DrawerState = {
  drawerHydrationState: DrawerHydrationState | null;
  openDrawerId: string | null;
};

const initialState: DrawerState = {
  drawerHydrationState: null,
  openDrawerId: null,
};

export default function drawerReducer(state: DrawerState = initialState, action: Action = { type: '' }): DrawerState {
  switch (action.type) {
    case CLOSE_DRAWER:
      return {
        ...state,
        drawerHydrationState: null,
        openDrawerId: null,
      };

    case OPEN_DRAWER:
      return {
        ...state,
        drawerHydrationState: null,
        openDrawerId: action.id,
      };

    case SET_DRAWER_HYDRATION_STATE:
      return {
        ...state,
        drawerHydrationState: action.payload,
      };

    default:
      return state;
  }
}
